﻿import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LogoComponent,
  HeaderComponent,
  HeaderLinksComponent,
  MyLoansListComponent,
  MyLoanGroupComponent,
  MyLoanComponent } from '../components';
import { BorrowerService } from '../services/borrower/borrower.service';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { LoanStateDirectorService as PLStateDirectorService } from '../../pages/personal-loans/shared/services/loan-state-director.service';
import { LoginRedirectServiceComponent } from '../services/login-redirect/login-redirect.service';
import { FinicityModule } from '@app/shared/services/finicity/finicity.module';
import { SessionService } from '@app/shared/services/session/shared/session/session-service/session.service';

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderLinksComponent,
    LogoComponent,
    MyLoansListComponent,
    MyLoanGroupComponent,
    MyLoanComponent
  ],
  imports: [
    CommonModule,
    FinicityModule
  ],
  exports: [
    HeaderComponent
  ],
  providers: [
    BorrowerService,
    DashboardService,
    {
      provide: 'PLStateDirectorService',
      useClass: PLStateDirectorService
    },
    LoginRedirectServiceComponent,
    SessionService
  ]
})
export class HeaderModule {}
